import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CartResponse } from '../models/cart-response.model';
import { CartRepository } from '../repositories/cart.respository';
import { CartCoverages } from '../models/cart-request.model';

export class CreateCartInternationalUseCase
    implements UseCase<CartCoverages[], CartResponse>
{
    constructor(private readonly repository: CartRepository) {}

    execute(cartCoverages: CartCoverages[]): Observable<CartResponse> {
        return this.repository.createCart(cartCoverages);
    }
}
